import { z } from "zod"

const nftRewardsItem = z.object({
  pairAddress: z.string(),
  bribeAddress: z.string(),
  tokens: z.array(
    z.object({
      address: z.string(),
      symbol: z.string(),
      amount: z.object({ wei: z.string(), value: z.string() }),
    }),
  ),
  pair: z.object({
    id: z.number(),
    address: z.string(),
    symbol: z.string(),
    displayName: z.string(),
    displayType: z.string(),
    token0: z.object({
      address: z.string(),
      symbol: z.string(),
      decimals: z.number(),
    }),
    token1: z.object({
      address: z.string(),
      symbol: z.string(),
      decimals: z.number(),
    }),
    decimals: z.number(),
    extendedType: z.string().nullable(),
    stable: z.boolean(),
    tags: z.array(z.string()),
  }),
})

export const rewardsByNftResponseSchema = z.record(z.string(), nftRewardsItem)

export type RewardsByNFTResponse = z.infer<typeof rewardsByNftResponseSchema>
export type RewardByNFTResponseItem = RewardsByNFTResponse[number]
